export default function Services() {
  const services = [
    {
      icon: 'ri-layout-grid-fill',
      title: 'Website Design & Development',
      description: 'Custom websites built with Shopify, WordPress, Wix, and more. Modern UI/UX design combined with advanced coding for fast, secure, and conversion-focused solutions.',
      features: ['Responsive Design', 'E-commerce Solutions', 'Custom CMS', 'SEO Optimized'],
      color: 'from-purple-500 to-blue-500',
      image: 'https://public.readdy.ai/ai/img_res/865855894dae9bf4ef5f1b1e9ee13c05.jpg'
    },
    {
      icon: 'ri-smartphone-fill',
      title: 'Mobile App Development',
      description: 'Native and cross-platform mobile applications for iOS and Android. Intuitive interfaces with powerful functionality that users love.',
      features: ['iOS & Android', 'Cross-Platform', 'App Store Optimization', 'Push Notifications'],
      color: 'from-blue-500 to-cyan-500',
      image: 'https://readdy.ai/api/search-image?query=Sleek%20mobile%20application%20interface%20displayed%20on%20modern%20smartphone%20mockup%2C%20showing%20beautiful%20app%20design%20with%20blue%20gradient%20colors%2C%20clean%20user%20interface%20elements%2C%20professional%20mobile%20app%20development%20showcase%2C%20bright%20studio%20lighting%2C%20white%20background&width=600&height=400&seq=service-mobile-002&orientation=landscape'
    },
    {
      icon: 'ri-movie-2-fill',
      title: '3D & 4K Animation',
      description: 'Stunning 3D animations and 4K video production that bring your brand to life. From product visualizations to explainer videos.',
      features: ['3D Modeling', '4K Video Production', 'Motion Graphics', 'Product Visualization'],
      color: 'from-pink-500 to-purple-500',
      image: 'https://readdy.ai/api/search-image?query=Professional%203D%20animation%20and%20motion%20graphics%20workspace%20showing%20colorful%20abstract%20geometric%20shapes%2C%20vibrant%20pink%20and%20purple%20gradient%20effects%2C%20high-quality%204K%20video%20production%20elements%2C%20modern%20digital%20art%20creation%2C%20bright%20studio%20lighting%2C%20white%20background&width=600&height=400&seq=service-animation-003&orientation=landscape'
    },
    {
      icon: 'ri-server-fill',
      title: 'Server Setup & Management',
      description: 'Robust server infrastructure setup and management. Cloud hosting, security configuration, and performance optimization for maximum uptime.',
      features: ['Cloud Hosting', 'Security Setup', 'Performance Tuning', '24/7 Monitoring'],
      color: 'from-green-500 to-emerald-500',
      image: 'https://readdy.ai/api/search-image?query=Modern%20data%20center%20server%20infrastructure%20with%20glowing%20green%20lights%2C%20organized%20server%20racks%2C%20cloud%20computing%20visualization%2C%20network%20connectivity%20icons%2C%20professional%20IT%20infrastructure%20setup%2C%20bright%20studio%20lighting%2C%20white%20background&width=600&height=400&seq=service-server-004&orientation=landscape'
    },
    {
      icon: 'ri-group-fill',
      title: 'Community Growth',
      description: 'Strategic community building and social media management. Grow your audience, increase engagement, and build lasting relationships.',
      features: ['Social Media Strategy', 'Content Creation', 'Engagement Analytics', 'Brand Building'],
      color: 'from-orange-500 to-red-500',
      image: 'https://readdy.ai/api/search-image?query=Social%20media%20community%20growth%20visualization%20with%20connected%20people%20icons%2C%20network%20nodes%2C%20engagement%20metrics%2C%20orange%20and%20red%20gradient%20colors%2C%20digital%20marketing%20analytics%20dashboard%2C%20bright%20studio%20lighting%2C%20white%20background&width=600&height=400&seq=service-community-005&orientation=landscape'
    },
    {
      icon: 'ri-code-s-slash-fill',
      title: 'Custom Development',
      description: 'Tailored software solutions with custom coding and advanced automation. API integrations, custom features, and scalable architecture.',
      features: ['API Integration', 'Custom Features', 'Automation', 'Scalable Solutions'],
      color: 'from-indigo-500 to-purple-500',
      image: 'https://readdy.ai/api/search-image?query=Clean%20programming%20code%20editor%20interface%20with%20colorful%20syntax%20highlighting%2C%20indigo%20and%20purple%20gradient%20accents%2C%20modern%20software%20development%20workspace%2C%20abstract%20code%20visualization%2C%20bright%20studio%20lighting%2C%20white%20background&width=600&height=400&seq=service-custom-006&orientation=landscape'
    }
  ];

  return (
    <section id="services" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="text-purple-600 font-semibold text-sm uppercase tracking-wider">Our Services</span>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mt-4 mb-6">
            Complete Digital Solutions
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            From concept to launch, we provide end-to-end digital services that drive results and exceed expectations.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div 
              key={index} 
              className="group bg-white rounded-3xl overflow-hidden border border-gray-100 hover:shadow-2xl transition-all duration-300 cursor-pointer"
            >
              <div className="relative h-48 overflow-hidden">
                <img 
                  src={service.image} 
                  alt={service.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className={`absolute inset-0 bg-gradient-to-br ${service.color} opacity-20 group-hover:opacity-30 transition-opacity`}></div>
              </div>
              
              <div className="p-8">
                <div className={`inline-flex items-center justify-center w-14 h-14 rounded-2xl bg-gradient-to-br ${service.color} mb-4 group-hover:scale-110 transition-transform`}>
                  <i className={`${service.icon} text-2xl text-white`}></i>
                </div>
                
                <h3 className="text-2xl font-bold text-gray-900 mb-3 group-hover:text-purple-600 transition-colors">
                  {service.title}
                </h3>
                
                <p className="text-gray-600 mb-6 leading-relaxed">
                  {service.description}
                </p>
                
                <ul className="space-y-2 mb-6">
                  {service.features.map((feature, idx) => (
                    <li key={idx} className="flex items-center text-gray-700">
                      <i className="ri-check-line text-green-500 mr-2"></i>
                      <span className="text-sm">{feature}</span>
                    </li>
                  ))}
                </ul>
                
                <button className="text-purple-600 font-semibold group-hover:gap-2 flex items-center cursor-pointer whitespace-nowrap">
                  Learn More
                  <i className="ri-arrow-right-line ml-1 group-hover:translate-x-1 transition-transform"></i>
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
